import type { RoutePath } from '@/shared/lib/ts-router';

/**
 * Адрес раздела выборок. Выборка и запись различаются необязательными сегментами: открытие
 * записи раздел не покидает, как и в разделе диалогов.
 */
export const SAMPLES_ROUTE_PATH = '/samples/:sampleId?/:id?' satisfies RoutePath;

/** Начало адресов раздела выборок — по нему список диалогов узнаёт, в каком разделе он открыт */
export const SAMPLES_ROUTE_PREFIX = '/samples';

/**
 * Сегмент выборки, означающий «выборка не выбрана». Нужен записи: сегменты выборки и записи идут
 * подряд, и без явного сегмента адрес записи прочитался бы как адрес выборки.
 */
export const NO_SAMPLE_ROUTE_SEGMENT = 'all';

/** Идентификатор выборки из сегмента адреса; `undefined` — выборка не выбрана */
export const parseSampleIdParam = (param?: string): number | undefined => {
  if (!param || param === NO_SAMPLE_ROUTE_SEGMENT) return undefined;
  const parsed = Number(param);
  return Number.isFinite(parsed) ? parsed : undefined;
};

/** Идентификатор фильтра списка диалогов по выборке. Колонки у фильтра нет — пользователь его не заполняет. */
export const SAMPLE_ID_FILTER_ID = 'sampleId';

/**
 * Имя таблицы личного вида списка выборки: вид хранится по каждой выборке отдельно, поэтому
 * у каждого пользователя своя раскладка в каждой из них. Без выбранной выборки — своя запись.
 */
export const getSampleTableName = (sampleId?: number): string =>
  sampleId == null ? 'samplesList' : `samplesList:${sampleId}`;
